"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("load-detail");
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
      "table",
      {
        className: bem("__info-table", "__info-table-with-references")
      },
      /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: bem("__info-table-header") }, /* @__PURE__ */ React.createElement("th", null, "Customer Load Id"), /* @__PURE__ */ React.createElement("th", null, "Details"), /* @__PURE__ */ React.createElement("th", null))),
      /* @__PURE__ */ React.createElement("tbody", null, _.map(this.props.customerLoads, this.customerLoad))
    )));
  },
  customerLoad: function(customerLoad, index) {
    const rowClasses = bem({
      "__info-table-data": true,
      even: index % 2 === 0
    });
    return /* @__PURE__ */ React.createElement("tr", { className: rowClasses, key: `customer_load_info_${index}` }, /* @__PURE__ */ React.createElement("td", { className: bem("__info-with-references") }, customerLoad.customer_load_id), /* @__PURE__ */ React.createElement("td", { className: bem("__info-with-references") }, this.customerLoadDetails(customerLoad)));
  },
  customerLoadDetails: function(customerLoad) {
    const references = [];
    this.extraReferences(customerLoad).forEach((ref) => {
      references.push(ref);
    });
    const html = _.map(references, function(ref) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: bem("__info-reference-pair"),
          key: `customer-load-reference-${ref.name}`
        },
        /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-name") }, ref.name, ":"),
        /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-value") }, ref.value)
      );
    });
    return /* @__PURE__ */ React.createElement("div", null, html);
  },
  extraReferences: function(tmsObject) {
    const refs = [];
    _.each(tmsObject.references, (value, name) => {
      refs.push({
        name,
        value
      });
    });
    return refs;
  }
});
